import React from "react";
import styled from "styled-components";
import { IH2HMatch } from "core-integration/src/store/leagues/types";
import { getShortNameFromId } from "../../utils/events";
import Result from "../Result";
import CupSummaryScore from "./CupSummaryScore";

const EventCell = styled.td`
  text-align: center;
`;

const StatusCell = styled.td`
  text-align: center;
`;

const CupSummaryData: React.FC<{
  match: IH2HMatch;
  entryId: number;
}> = ({ match, entryId }) => {
  const resultChar = match.winner === entryId ? "W" : match.winner ? "L" : "";
  return (
    <>
      <EventCell>{getShortNameFromId(match.event)}</EventCell>
      <StatusCell>
        {match.winner ? (
          <Result resultChar={resultChar} />
        ) : (
          <CupSummaryScore match={match} entryId={entryId} />
        )}
      </StatusCell>
    </>
  );
};

export default CupSummaryData;
